import request from '@/utils/request'

// 发送登录验证码
// 同一手机号5分钟内最多获取3次
// 请求参数: { phone: "手机号" }
// 返回: { code: 0, data: {}, message: "" }
export function sendLoginSmsCode(data) {
  return request({
    url: '/api/frontend/login/sms',
    method: 'post',
    data
  })
}

// 学员登录接口
// 支持手机号+密码登录（loginType=password）和手机号+验证码登录（loginType=sms）
// 请求参数: {
//   captchaCode: "", // 图形验证码
//   captchaId: "",  // 图形验证码ID
//   loginType: "",  // 登录类型 password/sms
//   password: "",   // 密码
//   phone: "",      // 手机号
//   smsCode: ""     // 短信验证码
// }
// 返回: {
//   code: 0,
//   data: {
//     expireTime: 0,    // token过期时间
//     token: "",        // 登录token
//     username: ""      // 用户名
//   },
//   message: ""
// }
export function login(data) {
  return request({
    url: '/api/frontend/login',
    method: 'post',
    data
  })
}

export function sendWechatBindPhoneSmsCode(data) {
  return request({
    url: '/api/frontend/wechat/bind-phone/sms',
    method: 'post',
    data
  })
}

export function wechatBindPhone(data) {
  return request({
    url: '/api/frontend/wechat/bind-phone',
    method: 'post',
    data
  })
}

// 学员登出接口
// 退出登录，清除Token
// 返回: { code: 0, data: {}, message: "" }
export function logout() {
  return request({
    url: '/api/frontend/logout',
    method: 'post'
  })
}

// 重置密码
// 通过手机号+验证码的形式找回密码并重新设置登录密码
// 请求参数: {
//   newPassword: "", // 新密码
//   phone: "",       // 手机号
//   smsCode: ""      // 短信验证码
// }
// 返回: { code: 0, data: {}, message: "" }
export function resetPassword(data) {
  return request({
    url: '/api/frontend/password/forgot/reset',
    method: 'post',
    data
  })
}

// 发送忘记密码验证码
// 发送用于重置密码的短信验证码，需要先验证手机号是否已注册
// 请求参数: { phone: "手机号" }
// 返回: { code: 0, data: {}, message: "" }
export function sendForgotPasswordSmsCode(data) {
  return request({
    url: '/api/frontend/password/forgot/sms',
    method: 'post',
    data
  })
}

// 获取图形验证码
// 用于登录时的图形验证码
// 返回: { code: 0, data: { captchaId: "", captchaImage: "" }, message: "" }
export function getCaptcha() {
  return request({
    url: '/api/frontend/captcha',
    method: 'get'
  })
}

// 验证图形验证码
// 请求参数: { captchaCode: "", captchaId: "" }
// 返回: { code: 0, data: {}, message: "" }
export function verifyCaptcha(data) {
  return request({
    url: '/api/frontend/captcha/verify',
    method: 'post',
    data
  })
}

// 手机号注册接口
// POST /api/frontend/register
// 请求参数: {
//   "password": "",   // 密码
//   "phone": "",      // 手机号
//   "smsCode": ""     // 短信验证码
// }
// 返回: {
//   "code": 0,
//   "data": {
//     "expireTime": 0,    // token过期时间
//     "token": "",        // 登录token
//     "username": ""      // 用户名
//   },
//   "message": ""
// }
export function register(data) {
  return request({
    url: '/api/frontend/register',
    method: 'post',
    data
  })
}

// 检查手机号是否已注册
// GET /api/frontend/register/check-phone
// 参数: phone (手机号)
// 返回: {
//   "code": 0,
//   "data": true,        // true表示已注册，false表示未注册
//   "message": ""
// }
export function checkPhoneRegistered(phone) {
  return request({
    url: '/api/frontend/register/check-phone',
    method: 'get',
    params: { phone }
  })
}

// 发送注册验证码
// POST /api/frontend/sms/send
// 发送用于注册的短信验证码，如果手机号已注册则提示直接登录
// 同一手机号5分钟内最多获取3次
// 请求参数: { phone: "手机号" }
// 返回: { code: 0, data: {}, message: "" }
export function sendRegisterSmsCode(data) {
  return request({
    url: '/api/frontend/sms/send',
    method: 'post',
    data
  })
}

export function getMyAddresses() {
  return request({
    url: '/api/frontend/personal/my-addresses',
    method: 'get'
  })
}

export function createMyAddress(addressInfo) {
  const info = addressInfo || {}
  return request({
    url: '/api/frontend/personal/my-addresses',
    method: 'post',
    data: info
  })
}

export function deleteMyAddress(id) {
  if (id == null || id === '') {
    return Promise.reject(new Error('缺少地址ID'))
  }
  return request({
    url: `/api/frontend/personal/my-addresses/${id}`,
    method: 'delete'
  })
}

export function updateMyAddress(addressInfo) {
  const info = addressInfo || {}
  const id = info.id ?? info.addressId ?? info.address_id
  if (id == null || id === '') {
    return Promise.reject(new Error('缺少地址ID'))
  }
  return request({
    url: `/api/frontend/personal/my-addresses/${id}`,
    method: 'put',
    data: { ...info, id }
  })
}

export function getMyCoupons(params) {
  return request({
    url: '/api/frontend/personal/my-coupons',
    method: 'get',
    params
  })
}

export function getAvailableCoupons() {
  return request({
    url: '/api/frontend/coupon/available',
    method: 'get'
  })
}

export function claimCoupon(couponId) {
  return request({
    url: '/api/frontend/coupon/claim',
    method: 'post',
    params: { couponId }
  })
}

export function getMyCouponsFromCouponApi(params) {
  return request({
    url: '/api/frontend/coupon/my',
    method: 'get',
    params
  })
}

export function getMyMessages(params) {
  return request({
    url: '/api/frontend/personal/my-messages',
    method: 'get',
    params
  })
}

export function markMyMessageRead(id) {
  return request({
    url: `/api/frontend/personal/my-messages/${id}/read`,
    method: 'put'
  })
}

export function getMyRegistrations(params) {
  return request({
    url: '/api/frontend/personal/my-registrations',
    method: 'get',
    params
  })
}

export function getAvailableProjects(params) {
  return request({
    url: '/api/frontend/personal/available-projects',
    method: 'get',
    params
  })
}

export function getMyProjects(params) {
  return request({
    url: '/api/frontend/personal/my-projects',
    method: 'get',
    params
  })
}

export function getMyCertificates() {
  return request({
    url: '/api/frontend/personal/my-certificates',
    method: 'get'
  })
}

export function registerProject(projectId, payload) {
  if (projectId == null || projectId === '') {
    return Promise.reject(new Error('缺少项目ID'))
  }
  const formData = new URLSearchParams()
  formData.append('projectId', String(projectId))
  const extra = payload && typeof payload === 'object' ? payload : null
  if (extra) {
    Object.keys(extra).forEach((key) => {
      const val = extra[key]
      if (val == null) return
      if (typeof val === 'string' || typeof val === 'number' || typeof val === 'boolean') {
        formData.append(key, String(val))
        return
      }
      try {
        formData.append(key, JSON.stringify(val))
      } catch (e) {
        formData.append(key, String(val))
      }
    })
  }
  return request({
    url: '/api/frontend/personal/register-project',
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: formData
  })
}

export function getProjectScore(projectId) {
  if (projectId == null || projectId === '') {
    return Promise.reject(new Error('缺少项目ID'))
  }
  return request({
    url: '/api/frontend/personal/project-score',
    method: 'get',
    params: { projectId },
    skipErrorMessage: true
  })
}

// 查询协议模板
export function getAgreementTemplate(typeCode) {
  return request({
    url: '/api/frontend/agreement/template',
    method: 'get',
    params: { typeCode }
  })
}

// 绑定学员协议
export function bindAgreement(data) {
  return request({
    url: '/api/frontend/agreement/bind',
    method: 'post',
    data
  })
}

export function getProjectCertificate(projectId) {
  if (projectId == null || projectId === '') {
    return Promise.reject(new Error('缺少项目ID'))
  }
  return request({
    url: '/api/frontend/personal/project-certificate',
    method: 'get',
    params: { projectId },
    skipErrorMessage: true
  })
}

export function getPersonalInfo() {
  return request({
    url: '/api/frontend/personal/info',
    method: 'get'
  })
}

// 获取默认头像列表
export function getDefaultAvatars() {
  return request({
    url: '/api/frontend/personal/default-avatars',
    method: 'get'
  })
}

// 实名认证
export function verifyRealName(data) {
  return request({
    url: '/api/frontend/realname/verify',
    method: 'post',
    data
  })
}

// 考试人脸检测-创建活体检测
export function createLivenessDetection(data) {
  return request({
    url: '/api/frontend/realname/liveness/create',
    method: 'post',
    data
  })
}

// 考试人脸检测-查询活体检测结果
export function getLivenessResult(data) {
  return request({
    url: '/api/frontend/realname/liveness/result',
    method: 'post',
    data
  })
}

// 考试人脸检测-人脸比对
export function verifyFaceCompare(data) {
  return request({
    url: '/api/frontend/realname/face-compare',
    method: 'post',
    data
  })
}

export function getPersonalOverview() {
  return request({
    url: '/api/frontend/personal/overview',
    method: 'get'
  })
}

export function uploadFrontendFile(file, path) {
  if (!file) return Promise.reject(new Error('缺少文件'))
  const formData = new FormData()
  formData.append('file', file)
  const params = {}
  const p = String(path || '').trim()
  if (p) params.path = p
  return request({
    url: '/api/frontend/file/upload',
    method: 'post',
    params,
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export function updatePersonalInfo(data) {
  return request({
    url: '/api/frontend/personal/info',
    method: 'put',
    data: data || {}
  })
}

// 设置默认地址
// PUT /api/frontend/personal/my-addresses/{id}/default
export function setDefaultAddress(addressId) {
  if (addressId == null || addressId === '') {
    return Promise.reject(new Error('缺少地址ID'))
  }
  return request({
    url: `/api/frontend/personal/my-addresses/${addressId}/default`,
    method: 'put'
  })
}

// 查询分销等级权益信息
// GET /api/frontend/personal/distributor-benefit
// 返回: { code: 200, data: { ... }, message: "操作成功" }
export function getDistributorBenefit() {
  return request({
    url: '/api/frontend/personal/distributor-benefit',
    method: 'get'
  })
}

// 购买分销商权益
// POST /api/frontend/personal/buy-distributor
export function buyDistributor(data) {
  return request({
    url: '/api/frontend/personal/buy-distributor',
    method: 'post',
    data
  })
}

// 申请提现
// POST /api/frontend/personal/withdraw/apply
export function applyWithdraw(data) {
  return request({
    url: '/api/frontend/personal/withdraw/apply',
    method: 'post',
    data
  })
}
// GET /api/frontend/personal/earnings-statistics
export function getEarningsStatistics() {
  return request({
    url: '/api/frontend/personal/earnings-statistics',
    method: 'get'
  })
}

// GET /api/frontend/personal/withdraw/statistics
export function getWithdrawStatistics() {
  return request({
    url: '/api/frontend/personal/withdraw/statistics',
    method: 'get'
  })
}

// 查询分销商收益明细
// GET /api/frontend/personal/earnings-details
export function getEarningsDetails(params) {
  return request({
    url: '/api/frontend/personal/earnings-details',
    method: 'get',
    params
  })
}

// 查询提现记录
// GET /api/frontend/personal/withdraw/records
export function getWithdrawRecords(params) {
  return request({
    url: '/api/frontend/personal/withdraw/records',
    method: 'get',
    params
  })
}

// 发送修改手机号验证码
// POST /api/frontend/personal/info/change-phone/sms
export function sendUpdatePhoneSmsCode(data) {
  return request({
    url: '/api/frontend/personal/info/change-phone/sms',
    method: 'post',
    data
  })
}

// 更新手机号
// PUT /api/frontend/personal/phone
export function updatePhone(data) {
  return request({
    url: '/api/frontend/personal/phone',
    method: 'put',
    data
  })
}
